import { render, staticRenderFns } from "./benefitDetail.vue?vue&type=template&id=64b95b3d&scoped=true&"
import script from "./benefitDetail.vue?vue&type=script&lang=js&"
export * from "./benefitDetail.vue?vue&type=script&lang=js&"
import style0 from "./benefitDetail.vue?vue&type=style&index=0&id=64b95b3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b95b3d",
  null
  
)

export default component.exports